import React from 'react';
import { Anchor, useCulture } from '@honeycomb/ui-core';
export function DirectionSwitcher(props) {
    const { dir, toggleDirection } = useCulture();
    return (React.createElement(Anchor, Object.assign({ button: true, onClick: () => toggleDirection === null || toggleDirection === void 0 ? void 0 : toggleDirection() }, props),
        "Switch to ",
        dir === 'ltr' ? 'RTL' : 'LTR'));
}
